module.exports = __webpack_public_path__ + "static/media/photo-16.a2074825.jpg";